import { useContext } from "react"

import { tableContext } from "../utils"

export function useFixedColumns() {
  const { fixedColumns } = useContext(tableContext)

  return fixedColumns
}
